// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarCompromissosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /agenda/buscar_compromissos
 *
 * Returns compromissos and bloqueios for a date range.
 *
 * @see Agenda_BuscarCompromissosCompromissoRow
 * @see Agenda_BuscarCompromissosBloqueioRow
 * @see Compromissos_model::pega_compromissos_agendados()
 * @see Bloqueios_agenda_model::list_for_agenda()
 */
import type { Agenda_BuscarCompromissosBloqueioRow } from './Agenda_BuscarCompromissosBloqueioRow'
import type { Agenda_BuscarCompromissosCompromissoRow } from './Agenda_BuscarCompromissosCompromissoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarCompromissosResponseDados {
compromissos: Agenda_BuscarCompromissosCompromissoRow[]
bloqueios: Agenda_BuscarCompromissosBloqueioRow[]
}

export type Agenda_BuscarCompromissosResponse = ApiResponse<Agenda_BuscarCompromissosResponseDados>;

registerResponseContract('Agenda_BuscarCompromissosResponse', {
  compromissos: {
    type: 'array',
    required: true,
    items: {
      compromisso_id:                    { type: 'number',  required: true },
      compromisso_titulo:                { type: 'string',  required: false },
      title:                             { type: 'string',  required: false },
      compromisso_total:                 { type: 'string',  required: false },
      backgroundColor:                   { type: 'string',  required: false },
      compromisso_data_hora_inicio:      { type: 'string',  required: false },
      start:                             { type: 'string',  required: false },
      compromisso_data_hora_fim:         { type: 'string',  required: false },
      end:                               { type: 'string',  required: false },
      compromisso_data_cadastro:         { type: 'string',  required: false },
      compromisso_operador_user_id:      { type: 'string',  required: false },
      compromisso_orcamento_id:          { type: 'number',  required: false },
      compromisso_franquia_id:           { type: 'number',  required: false },
      compromisso_forma_pagamento:       { type: 'number',  required: false },
      compromisso_forma_pagamento_label: { type: 'string',  required: false },
      compromisso_numero_parcelas:       { type: 'number',  required: false },
      compromisso_nome_cliente:          { type: 'string',  required: false },
      compromisso_observacao:            { type: 'string',  required: false },
      compromisso_origem:                { type: 'number',  required: false },
      compromisso_status:                { type: 'string',  required: true },
      compromisso_status_original:       { type: 'string',  required: true },
      compromisso_tipo:                  { type: 'number',  required: false },
      compromisso_checkin:               { type: 'string',  required: false },
      compromisso_checkout:              { type: 'string',  required: false },
      compromisso_entrou_sem_problemas:  { type: 'number',  required: false },
      compromisso_status_financeiro:     { type: 'number',  required: false },
      compromisso_foi_reagendado:        { type: 'number',  required: false },
      compromisso_valor_recebido:        { type: 'string',  required: false },
      cliente_id:                        { type: 'number',  required: true },
      cliente_location_id:               { type: 'number',  required: false },
      cliente_location_type:             { type: 'string',  required: false },
      cliente:                           { type: 'string',  required: true },
      franquia_nome:                     { type: 'string',  required: false },
      localidade:                        { type: 'string',  required: false },
      status_financeiro:                 { type: 'string',  required: false },
      operador:                          { type: 'string',  required: false },
      servicos:                          { type: 'string',  required: false },
      servicos_compromisso:              { type: 'string',  required: false },
      nome_operador:                     { type: 'string',  required: false },
      avatar_operador:                   { type: 'string',  required: false },
      borderColor:                       { type: 'string',  required: false },
      compromisso_valor_total:           { type: 'number',  required: false },
      valor_restante:                    { type: 'number',  required: false },
      valor_total:                       { type: 'number',  required: false },
      franchise_id:                      { type: 'number',  required: false },
    },
  },
  bloqueios: {
    type: 'array',
    required: true,
    items: {
      bloqueio_agenda_id:               { type: 'number',  required: true },
      bloqueio_agenda_titulo:           { type: 'string',  required: false },
      bloqueio_agenda_operador_user_id: { type: 'string',  required: false },
      bloqueio_agenda_criador_user_id:  { type: 'string',  required: false },
      bloqueio_agenda_data_hora_inicio: { type: 'string',  required: false },
      bloqueio_agenda_data_hora_fim:    { type: 'string',  required: false },
      bloqueio_agenda_data_cadastro:    { type: 'string',  required: false },
      start:                            { type: 'string',  required: false },
      end:                              { type: 'string',  required: false },
      bloqueio_operador_nome:           { type: 'string',  required: false },
      avatar_operador:                  { type: 'string',  required: false },
      backgroundColor:                  { type: 'string',  required: false },
      borderColor:                      { type: 'string',  required: false },
    },
  },
})
